import { useApiQuery } from "../../../../../../../common/infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../../../../../../../common/infrastructure/routes/endpointsMetadata";
import { ICardRenewalOptionModel } from "../models/cardRenewalOptionModel";

export const cardRenewalOptionsQueryKey = (userId?: number) => [
  endpointsMetadata.plan.getCardRenewalOptions,
  userId,
];

/**
 * The client's cards "Поднови карта" can renew, newest first. Shared by the profile menu
 * (which hides the item when there are none) and the dialog, so both read one cached request.
 */
export const useCardRenewalOptions = (
  userId: number | undefined,
  enabled: boolean,
) =>
  useApiQuery<ICardRenewalOptionModel[]>({
    queryKey: cardRenewalOptionsQueryKey(userId),
    endpoint: `${endpointsMetadata.plan.getCardRenewalOptions}?userId=${userId}`,
    enabled: enabled && !!userId,
    globalIsLoading: false,
    // A refusal (another studio's client, ...) will not change on retry.
    retry: false,
  });
